import styled from 'styled-components';

export const ProgressDotContainer = styled.div<{ isActive?: boolean }>`
  display: flex;
  flex-direction: column;

  border-radius: 50%;
  width: 16px;
  height: 16px;
  margin: 0;

  background: ${(props) =>
    props.isActive
      ? props.theme.colors.theme.primary.default
      : props.theme.colors.text.light};
`;
